import axios from "axios";
import { readCache } from "../../utils/readCache";

const getMenuItems = () =>
  readCache.read(
    "legacy:menus",
    async () => {
      const response = await axios.get("/client/menu");
      if (!Array.isArray(response.data))
        throw new Error("Invalid menu response");
      return response;
    },
    300000
  );

const getCategoriesById = async (id, options) => {
  const response = await axios.get("/client/menu/" + id, options);
  // Older menu-detail responses omit the name needed by the Kids theme.
  if (!response.data?.name && Array.isArray(response.data?.categories)) {
    const menus = await getMenuItems();
    return {
      ...response,
      data: {
        ...response.data,
        name:
          menus.data.find((menu) => String(menu.id) === String(id))?.name || ""
      }
    };
  }
  return response;
};

const getLabelsById = (id, options) =>
  axios.get("/client/category/" + id, options);

export { getMenuItems, getCategoriesById, getLabelsById };
